import { Loader } from 'components';
import { AuthLayout } from 'components/layout';
import { Container } from 'design-system/atoms/layout';
import { useNameComponent } from 'hooks';
import { useRouter } from 'next/router';
import React from 'react';
import { ChangePassword, PasswordRecoveryEmail } from '../../features/auth/ui';

function ForgotPasswordPage() {
  const router = useRouter();
  const { token } = router.query;

  if (!router.isReady) {
    return <Loader fullscreen />;
  }
  return (
    <AuthLayout>
      <Container maxWidth="sm">
        {token ? (
          <ChangePassword />
        ) : (
          <PasswordRecoveryEmail
            // eslint-disable-next-line react-hooks/rules-of-hooks
            dataCy={useNameComponent('recover-password')}
          />
        )}
      </Container>
    </AuthLayout>
  );
}

export default ForgotPasswordPage;
